export function mainPads () {
  let headerHeight = $('#header').height();
  let documentHeight = $(window).height();
  let documentWidth = $(window).width();

  $('#home-slider-container, #hero').css('padding-top', headerHeight);
  $('#header').next('#main').css('padding-top', headerHeight);

  if(documentWidth < 998) {
    $('#main-nav-bar').css('height' , documentHeight - headerHeight - 50);
  } else {
    $('#main-nav-bar').css('height' , 'auto');
  }
}




// WEBPACK FOOTER //
// ./scripts/includes/main-top-padding.js